import ParametersFormatter from "../../parametersFormatting/ParametersFormatter"
import ATReportParamsStringBuilder from '../reportParamsStringBuilder/ATReportParamsStringBuilder'

export default class OvertimeReportParametersFormatter extends ParametersFormatter {
    init({selectorsData, dateFormat}) {
        this.reportParamsStringBuilder = new ATReportParamsStringBuilder({
            data: {
                users: selectorsData.users,
                userGroups: selectorsData.userGroups,
                timeZoneGroups: selectorsData.timeZoneGroups,
                manageableUserIds: selectorsData.manageableUserIds,
                projectsWithMaIds: selectorsData.projectsWithMaIds,
            },
            dateFormat: dateFormat,
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        })
        return this;
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/ParametersFormatter.js